<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div class="nav gap-x-3" title="KeHuList" data-title="会议日志">
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div
      class="content c-table-box mt-2 bg-white p-2.5 rounded-lg"
      v-if="state.list_data?.length > 0"
    >
      <div class="overflow-y-auto flex flex-col gap-y-3 mt-3">
        <div
          class="bg-white p-4 flex flex-col gap-y-2 border-gray-100"
          :class="index != 0 ? 'border-t' : ''"
          v-for="(item, index) in state.list_data"
          :key="item"
        >
          <ul class="flex gap-x-5 mb-1 items-center">
            <strong class="text-lg">{{ item.date }}</strong>
            <li class="flex-1 text-xs text-gray-400">
              {{ item.d_meeting_log_type_name }}
            </li>
            <!-- <el-button
              type="danger"
              plain
              link
              @click="onDelete(item)"
              style="margin-left: -5px"
            >
              <template #icon>
                <el-icon :size="18" class="font-bold">
                  <Delete />
                </el-icon>
              </template>
            </el-button> -->
          </ul>
          <c_cell title="内容">
            <template #default>
              <div class="whitespace-pre-wrap" v-html="item.content"></div>
            </template>
          </c_cell>
          <c_cell title="附件">
            <template #default>
              <div
                class="flex flex-wrap gap-x-3 gap-y-2"
                v-if="item.attachment?.length > 0"
              >
                <li
                  v-for="file in item.attachment"
                  class="hover:underline cursor-pointer text-green-700"
                  @click="$openFile(file.file_url)"
                >
                  {{ file.filename }}
                </li>
              </div>
              <text v-else>-</text>
            </template>
          </c_cell>
          <div class="flex items-center text-gray-400 text-xs gap-x-2 mt-2">
            <text class="text-sm text-gray-600">
              {{ item?.add_admin_name }}
            </text>
            <text>{{ item?.add_department_name }}</text>
            <text class="ml-1">{{ item?.create_time }} 创建</text>
          </div>
        </div>
      </div>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
    <div class="text-center" v-else>
      <el-image :src="require('@/assets/images/nodata.png')" />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    title="新建会议日志"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :id="state.selectId"
      :meeting_id="props.meeting_id"
      @close="
        (refresh) => {
          state.showInfo = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meeting_log_page, meeting_log_delete } from "@/http/meeting";
import { onDeleteConfirm } from "@/utils/funcs";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_info,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      meeting_log_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(meeting_log_delete, row.id, onLoad, {
        filed: "会议日志",
        name: "",
      });
    };

    return { state, props, onLoad, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
